'use strict';

var propTypes = {exports: {}};

exports.__module = propTypes;
//# sourceMappingURL=index6.cjs.map
